<template>
  <fieldset :id="field.name" class="fieldset-reset" :class="{ 'required-empty': requiredEmpty }" :style="field.style || undefined">
    <legend class="block text-sm font-semibold text-q4cl-primary mb-1.5 leading-snug">
      {{ displayName }}
      <span v-if="field.required" class="tag-required" :aria-label="$t('必須項目')">{{ $t('※必須') }}</span>
      <span v-else-if="showOptional" class="tag-optional" aria-hidden="true">{{ $t('※任意') }}</span>
    </legend>

    <div
      v-if="field.description"
      class="text-sm text-q4cl-muted mb-2 leading-relaxed"
      v-html="sanitizedDescription"
    ></div>

    <!--
      旧旧版踏襲: 親 div は素の縦並び、 inline=true のときは label に display: inline-block。
      flex 使わないので「画面幅 ÷ N で均等分割 → 文字が縦書き」 が起こらない。
    -->
    <div :class="inline ? '-mr-2' : 'space-y-1.5'" role="group">
      <label
        v-for="(sel, key) in field.sels"
        :key="key"
        :class="['choice-label', sel.checked ? 'checked' : '', inline ? 'choice-inline' : '']"
      >
        <input
          type="checkbox"
          :name="field.name + '__' + key"
          :checked="sel.checked"
          @change="toggle(key, $event.target.checked)"
        />
        <span class="text-sm text-q4cl-ink">{{ $t(sel.value) }}</span>
      </label>
    </div>

  </fieldset>
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const i18n = window.i18nStore;
    const inline = Vue.computed(() => !!props.field.inline);

    const displayName = Vue.computed(() => i18n ? i18n.i18n(props.field.dispname) : props.field.dispname);

    // 旧旧版踏襲: 配列なら \n で join、 marked.parse で block-level Markdown サポート
    const sanitizedDescription = Vue.computed(() => {
      try {
        const raw = props.field.description;
        if (!raw) return '';
        const joined = Array.isArray(raw) ? raw.join('\n') : raw;
        const translated = i18n ? i18n.i18n(joined) : joined;
        return DOMPurify.sanitize(marked.parse(translated));
      } catch (e) { return props.field.description; }
    });

    function toggle(key, checked) {
      props.field.sels[key].checked = checked;
    }

    const requiredEmpty = Vue.computed(() => {
      const fs = window.fieldSerializer;
      return fs ? fs.isRequiredAndEmpty(props.field) : false;
    });

    return { inline, displayName, sanitizedDescription, toggle, requiredEmpty };
  }
};
</script>
